export const state = () => ({
    /**
     * User attributes from flash-proiles
     */
    user: null,
    /**
     * Percent completion of custom auth flow (displayed in login/auto.vue)
     */
    authProgress: 0,
    /**
     * How many seconds untill a user can request another magic link
     */
    countdown: 0,
    timerId: null,
});

export const mutations = {
    setUser(state, user) {
        state.user = user;
    },
    setAuthProgress(state, progress) {
        state.authProgress = progress;
    },
    setCountdown(state, seconds) {
        state.countdown = seconds;
    },
    setTimerId(state, id) {
        state.timerId = id;
    },
};

export const actions = {
    startCountdown({ commit, state }) {
        if (state.timerId) return;
        commit('setCountdown', 60);

        const id = setInterval(() => {
            if (state.countdown > 0) {
                commit('setCountdown', state.countdown - 1);
            } else {
                clearInterval(id);
                commit('setTimerId', null);
            }
        }, 1000);

        commit('setTimerId', id);
    },

    stopCountdown({ commit, state }) {
        if (state.timerId) {
            clearInterval(state.timerId);
            commit('setTimerId', null);
        }
        commit('setCountdown', 0);
    },
};

export const getters = {};
